import { useOrderRefundApi } from "../api/OrderRefundApiClient";
import { OrderRefundFrontendService } from "../services/OrderRefundFrontendService";

export const useOrderRefundService = (): OrderRefundFrontendService =>
  new OrderRefundFrontendService(useOrderRefundApi());
